export enum ConnectionDirection {
  Send = 'Send',
  Receive = 'Receive',
}
